/**
 * The inference queue turned this request away at the door — the waiting
 * line hit its cap. A friendly outcome, not a failure: callers render the
 * "study room is full" copy without error styling.
 */
export class QueueFullError extends Error {
  constructor() {
    super('The study room is full right now — every seat is taken. Please try again in a few minutes.');
    this.name = 'QueueFullError';
  }
}
